import _ from 'lodash';
import { useCallback, useMemo } from 'react';

import { AppID } from '@playq/octopus-common';
import { FileFeature, FileID, FileResponse } from '@playq/octopus2-files';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { assetGetKeys } from './constants';

export const useAssetGet = (
  appID?: AppID,
  id?: FileID,
  features: FileFeature[] = [],
  options?: IUseQueryOptionsExtended<FileResponse | undefined, GenericFailure | Error>
) => {
  const enabled = useMemo(() => {
    const isIdValid = !_.isNil(id) && !_.isNil(appID);
    return isIdValid && (options?.enabled ?? true);
  }, [appID, id, options?.enabled]);

  const keys = useMemo(() => assetGetKeys.concat(id, appID), [id, appID]);

  const { mutate, ...res } = useEitherQuery(
    keys,
    () => services2.appAssetsService.getFile(appID as AppID, id as FileID, features),
    { ...options, enabled }
  );

  const mutateUpdatedAsset = useCallback(
    (asset: FileResponse) => {
      if (res.data) {
        mutate(asset);
      }
    },
    [mutate, res.data]
  );

  return {
    fileResponse: res.data,
    ...res,
    tags: keys,
    mutate,
    mutateUpdatedAsset,
  };
};
